module.exports = __webpack_public_path__ + "static/media/part-detail-slide-4.51c16f04.jpg";